import styled from "styled-components";

export const StepsCardsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: ${({ theme }) => theme.spacing.x20};
    column-gap: ${({ theme }) => theme.spacing.small};
    width: 100%;
    max-width: 330px;
    margin-top: ${({ theme }) => theme.spacing.xLarge};
`;

export const StepCardContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.medium};
    position: relative;
    min-height: 120px;
`;

export const StepNumberBadge = styled.div`
    position: absolute;
    top: -${({ theme }) => theme.spacing.large};
    left: 50%;
    transform: translateX(-50%);
    width: 36px;
    height: 36px;
    background-color: #4E9176;
    border-radius: ${({ theme }) => theme.cornerRadius.rounded};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;

export const StepIconWrapper = styled.div`
    width: 122px;
    height: 122px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
    border-radius: 10px;
    background: #C8F9E5;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

export const StepIcon = styled.img`
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
    object-fit: contain;
    object-position: center;
`;

export const StepTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxSmall};
    align-items: center;
    text-align: center;
`;

export const ReferNowButton = styled.button`
    background-color: #4E9176;
    color: white;
    border: none;
    border-radius: ${({ theme }) => theme.cornerRadius.medium};
    padding: ${({ theme }) => theme.spacing.medium} ${({ theme }) => theme.spacing.xLarge};
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin-top: ${({ theme }) => theme.spacing.xLarge};
    width: 200px;
`;

